export default __webpack_public_path__ + "static/media/4.be16a24d.svg";